export default {
  purple: '#A227C5',
  orange: '#E76119',
  green: '#31A03C',
  blue: '#4191ED',
  red: '#C73732',
  yellow: '#D28E09',
  navy: '#1f3751',
  plum: '#413ECF',
  magenta: '#D63BAA',
  brown: '#745138',
  owner: '#FFD000',
};
